export const formatISK = (price) => price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");


// WEBPACK FOOTER //
// ./src/services/utils/Prices.js